module.exports = __webpack_public_path__ + "static/media/CareerNeeds.119cbb93.png";